// extracted by mini-css-extract-plugin
module.exports = {"free-tools-for-managers-hero":"styles_free-tools-for-managers-hero__IQUX_"};